import { type FilterStatus, type TabComponentProps } from '@valiant/ui-shared'
import { type TransactionStatus, type TransactionType } from '@/generated/graphql'
import { useDebounce } from '@valiant/ui-shared'
import { useQueryParams } from '@valiant/ui-shared'
import { TransactionsContent } from '@/components/tables/TransactionsContent'

export function TransactionsTab({
  initialStatus = null,
  groupId,
  companyId,
  searchTerm,
}: TabComponentProps) {
  const queryParams = useQueryParams()

  // Initialize search from query params or empty string
  const searchInput = searchTerm || queryParams.search || ''

  // Get status, type, and isFlagged from query params, with fallback to initialStatus for backward compatibility
  const selectedStatus =
    (queryParams.status as TransactionStatus | null) || (initialStatus as TransactionStatus | null)
  const selectedType = queryParams.type as TransactionType | null
  const isFlagged =
    queryParams.isFlagged === 'true' ? true : queryParams.isFlagged === 'false' ? false : null

  // Use the existing debounce hook
  const debouncedSearch = useDebounce(searchInput || '')

  // Function to update filters atomically
  const updateFilters = (
    status: FilterStatus | null,
    type: TransactionType | null,
    flagged: boolean | null = null,
  ) => {
    queryParams.updateMultiple({
      status: status || undefined,
      type: type || undefined,
      isFlagged: flagged === null ? undefined : flagged.toString(),
    })
  }

  return (
    <TransactionsContent
      debouncedSearch={debouncedSearch}
      selectedStatus={selectedStatus}
      selectedType={selectedType}
      isFlagged={isFlagged}
      groupId={groupId}
      companyId={companyId}
      onFilter={updateFilters}
    />
  )
}
